import React, { useState, useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import api from '../../../api';
import GLightbox from 'glightbox';
import 'glightbox/dist/css/glightbox.css';

const StudentLifeSection = () => {
  const { miniSlug, slug } = useParams();
  const [sectionData, setSectionData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await api.get(`${process.env.REACT_APP_API_URL}/api/${miniSlug}/${slug}/student-life`);
        setSectionData(response.data);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [miniSlug, slug]);

  // Initialize GLightbox when images are loaded
    useEffect(() => {
        if (!sectionData) return;

        // Destroy any existing instances to avoid duplicates
        const lightbox = GLightbox({
            selector: '.glightbox',
            touchNavigation: true,
            loop: true,
            zoomable: true,
            autoplayVideos: true,
        });

        return () => {
            if (lightbox) {
            lightbox.destroy();
            }
        };
    }, [sectionData]);

  if (loading || error || !sectionData || sectionData.content.length === 0) {
    return null;
  }

  const galleryImages =
    sectionData.additional_data?.gallery?.length > 0
      ? sectionData.additional_data.gallery
      : [
          `${process.env.REACT_APP_API_URL}/public/${sectionData.primary_image}`,
          `${process.env.REACT_APP_API_URL}/public/${sectionData.additional_data?.secondary_image}`,
        ];

  const firstImage = galleryImages[0] || '/default-images/student-life-1.webp';

  return (
    <section className="student_life_section mb-0 mb-md-5" id="student-life">
      <div className="container">
        <div className="sec-title text-center">
                            <h2>{sectionData.title || 'Student Life'}</h2>
                        </div>
       

        <div className="row d-flex justify-content-center align-items-center">
          {/* Left image gallery */}
          <div className="col-md-5 mb-9 mb-md-0">
            <div className="student-life-gallery position-relative">
              <div className="position-relative">
                <a
                  href={firstImage}
                  className="glightbox"
                  data-gallery="student-life-gallery"
                >
                  <div className="img-wrapper position-relative">
                    <img
                      src={firstImage}
                      alt="student-img"
                      className="img-fluid"
                    />
                    {/* <div className="overlay-icon">
                      <i className="fa fa-plus"></i>
                    </div> */}
                  </div>
                </a>
              </div>

              {/* Hidden gallery links */}
              {galleryImages.slice(1).map((img, index) => (
                <a
                  key={index}
                  href={img}
                  className="glightbox d-none"
                  data-gallery="student-life-gallery"
                ></a>
              ))}
            </div>
          </div>

          {/* Right content section */}
          <div className="col-md-7 mt-3 mt-md-0">
            <div className="student-life-content">
              <div dangerouslySetInnerHTML={{ __html: sectionData.content }} />
              <div className="mt-3 mb-3 mb-md-0">
                <Link
                  to={`/${miniSlug}/${slug}/student-life`}
                  className="readmoreall"
                >
                  <span className="txt">
                    {sectionData.additional_data?.button_text || 'Learn More'}
                    <i className="ms-2 fa fa-caret-right"></i>
                  </span>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default StudentLifeSection;
